import React from 'react';
import { useTranslation } from 'react-i18next';
import FilterCategoryList from './FilterCategoryList';
//
// Вспомогательный компонент для отображения списка основных категорий
//
const FilterCategoryMain = ({ folders, orphans, title }) => {
    const { i18n } = useTranslation();
    const lang = i18n.language;
    // Приходится вставлять отдельно <HR/> для отбивки списка категорий от географии т.к.
    // параметр border у FilterCategoryList не годится из-за того, что первая категория
    // может не отображаться если в ней нет участников, а знать об этом тут мы не можем.
    return (            
    <React.Fragment>
        <hr/>
        {folders.map(folder => (
            <FilterCategoryList 
                key={folder._id} 
                title={folder.name[lang]} 
                list={folder.categories}
            />
        ))}
        
        <FilterCategoryList title={title} list={orphans}/>
    </React.Fragment>
    );
};

export default FilterCategoryMain;
